import { Filter16, ChevronDown16 } from 'ui/icons';
import { BUTTON_SIZES, BUTTON_VARIANTS } from 'ui/button';
import { useTranslation } from '../../hooks';
import { SegmentationUsersCount } from '../SegmentationUsersCount';
import {
  FilterUsersFurtherHeaderActionsWrapper,
  FilterUsersFurtherHeaderWrapper,
  StyledGhostButton,
  UsersCountWrapper,
  UsersSuffix,
} from './QueryBuilderSection.styles';
import { UpdateActionMenu } from '../sidePanel/UpdateActionMenu';
import { SaveActionMenu } from '../sidePanel/SaveActionMenu';
import { useSegmentationQueryContext } from 'modules/segmentation/contexts/segmentationQuery';

export const testIds = {
  filterUsersButton: 'filter-users-button',
  filterUsersFurtherHeader: 'filter-users-further-header',
  filterUsersListCount: 'filter-users-further-user-count',
};

export const FilterUsersFurtherHeader = ({
  expandQueryBuilder,
}: {
  expandQueryBuilder: () => void;
}) => {
  const { t } = useTranslation();
  const { count } = useSegmentationQueryContext();
  return (
    <FilterUsersFurtherHeaderWrapper data-test={testIds.filterUsersFurtherHeader}>
      <StyledGhostButton
        data-header-collapsed={true}
        data-test={testIds.filterUsersButton}
        onClick={expandQueryBuilder}
        size={BUTTON_SIZES.MEDIUM}
      >
        <Filter16 height={20} width={20} />
        <span>{t('button.filterListUsers')}</span>
        <ChevronDown16 />
      </StyledGhostButton>
      <FilterUsersFurtherHeaderActionsWrapper>
        <UpdateActionMenu variant={BUTTON_VARIANTS.GHOST} />
        <SaveActionMenu variant={BUTTON_VARIANTS.GHOST} />
        <UsersCountWrapper>
          <SegmentationUsersCount dataTest={testIds.filterUsersListCount} />
          <UsersSuffix>{count === 1 ? t('header.users_one') : t('header.users_other')}</UsersSuffix>
        </UsersCountWrapper>
      </FilterUsersFurtherHeaderActionsWrapper>
    </FilterUsersFurtherHeaderWrapper>
  );
};
